import React, { useEffect } from "react";
import CustomerIncidentForm from "@common/components/shared/CustomerIncident/CustomerIncidentForm";
import { useCustomerIncident } from "@common/components/hooks/useCustomerIncident";
import { FormProvider } from "react-hook-form";
import useComplianceView from "../../../hooks/useComplianceView.js";
import { CUSTOMER_INCIDENT_TYPE } from "../details/EventDetailsForm.js";
import { parseCustomerIncidentResponse } from "@common/components/helpers/compliance.js";
import ComplianceHeader from "../ComplianceHeader.js";
import useIncidentContainer from "../../../hooks/useIncidentContainer.js";
import { Loader } from "semantic-ui-react";

const CustomerIncidentContainer = () => {
  const {
    formLoading,
    incident: {
      record,
      record: {
        incidentType: { name },
      },
    },
  } = useComplianceView();
  const {
    methods,
    methods: { reset },
  } = useCustomerIncident();
  const { onRowUpdate } = useIncidentContainer();

  useEffect(() => {
    if (name !== CUSTOMER_INCIDENT_TYPE) {
      return;
    }
    reset(parseCustomerIncidentResponse(record));
  }, [record]);

  if (formLoading) {
    return <Loader active />;
  }

  return (
    <FormProvider {...methods}>
      <ComplianceHeader title="Customer Incident" loadRecord={onRowUpdate} />
      <CustomerIncidentForm />
    </FormProvider>
  );
};

export default CustomerIncidentContainer;
